import { gsap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);


export default class Nav {
    constructor() {
        this.init();
    }

    init() {

        this.initShowHideNav();

        this.attachAnchorListeners();
        this.scrollToAnchorOnLoad();

    }

    initShowHideNav() {
        const showhideNav = gsap.from('.nav-sticky', {
            opacity: 0,
            paused: true,
            duration: 0.5,
        }).progress(1);

        ScrollTrigger.create({
            start: 'top top',
            end: 99999,
            onUpdate: (self) => {
                const navSticky = document.querySelector('.nav-sticky');
                if (self.direction === -1) {
                    showhideNav.play();
                    navSticky.classList.add('has-bg');
                } else {
                    showhideNav.reverse();
                    navSticky.classList.add('has-scrolled');
                }

                const minScrollTop = document.body.classList.contains('admin-bar') ? 32 : 0;
                if (window.scrollY <= minScrollTop) {
                    navSticky.classList.remove('has-scrolled');
                    navSticky.classList.remove('has-bg');
                }
            },
        });
    }

    attachAnchorListeners() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function(e) {
                e.preventDefault();
                const targetId = this.getAttribute('href');
                const targetElement = document.querySelector(targetId);

                if(targetElement) {
                    gsap.to(window, {
                        scrollTo: {
                            y: targetElement,
                            autoKill: false
                        },
                        duration: 1
                    });
                }
            });
        });
    }

    scrollToAnchorOnLoad() {
        const hash = window.location.hash;
        if (hash) {
            const targetElement = document.querySelector(hash);
            if (targetElement) {
                gsap.to(window, {
                    scrollTo: {
                        y: targetElement,
                        autoKill: false
                    },
                    duration: 1,
                    delay: 0.25
                });
            }
        }
    }
}
